import { TextField, Tooltip } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import axios from "axios";
import fileDownload from "js-file-download";
import moment from "moment";
import React, { useState, useContext, useEffect } from "react";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { APICall } from "../../../Helpers/API/APICalls";
import {
  GetDropDownList,
  GetSumPeriodReportData,
  NewPeriodReportExportToExcel,
} from "../../../Helpers/API/APIEndPoints";
import { getContext, LoaderContext } from "../../../Helpers/Context/Context";

const NewPeriodReport = () => {
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const [customerOptions, setCustomerOptions] = useState([]);
  const [customerSelectData, setCustomerSelectData] = useState([]);
  const [engagementOptions, setEngagementOptions] = useState([]);
  const [engagementSelectedData, setEngagementSelectedData] = useState([]);
  const [engagementTypeOptions, setEngagementTypeOptions] = useState([]);
  const [engagementTypeSelectedData, setEngagementTypeSelectedData] = useState(
    []
  );
  const [resourceOptions, setResourceOptions] = useState([]);
  const [resoucreSelectData, setResourceSelectData] = useState([]);
  const [requestObject, setRequestObject] = useState([{ count: 0 }]);

  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const [costCenterOptions, setCostCenterOptions] = useState([]);
  const [costCenterSelectData, setCostCenterSelectData] = useState([]);

  const {EmployeeId, RoleId} = getContext();
  const RoleIdArray = RoleId.split(",");
  const [employeeRoleId , setEmployeeRoleId] = useState(0);
  
  let formErrorObj = {};

  const SelectOnChange = (event, apiField) => {
    if (apiField === "customer") {
      setCustomerSelectData(event);
    }

    if (apiField === "costCenter") {
      setCostCenterSelectData(event);
    }

    if (apiField === "engagement") {
      setEngagementSelectedData(event);
    }

    if (apiField === "engagementType") {
      setEngagementTypeSelectedData(event);
    }

    if (apiField === "resource") {
      setResourceSelectData(event);
    }

    if (apiField === "fromDate") {
      setFromDate(event);

      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["fromDate_isEmpty"]: "From date can not be empty",
        }));
      }
    }
    if (apiField === "toDate") {
      setToDate(event);
      if (event) {
        setFormErrors((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: undefined,
        }));
      } else {
        setFormErrors((preState) => ({
          ...preState,
          ["toDate_isEmpty"]: " To date can not be empty",
        }));
      }
    }
  };



  // console.log('Employee =>>', EmployeeId)
  // console.log('RoledId =>>', RoleId)
  // console.log("EmployeeRoleId =>>",employeeRoleId)

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,
    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
  };

  useEffect(() => {
    onLoadApi();
  }, []);

  const onLoadApi = async () => {
    await customerApiCall();
    await engagementApiCall();
    await engagementTypeApiCall();
    await resourceApiCall();
    await GetCostCenterOptions();
  };

  useEffect(() => {
    let customers = ConvertArrayToString(customerSelectData);
    let resource = ConvertArrayToString(resoucreSelectData);
    let engagement = ConvertArrayToString(engagementSelectedData);
    let engagementType = ConvertArrayToString(engagementTypeSelectedData);
    let costcenterId = ConvertArrayToString(costCenterSelectData);
    if(RoleIdArray.includes("3")){
      setEmployeeRoleId(3);
    }else if(RoleIdArray.includes("8")){
      setEmployeeRoleId(8);
    }else if(RoleIdArray.includes("2")){
      setEmployeeRoleId(2);
    }else if(RoleIdArray.includes("1")){
      setEmployeeRoleId(1);
    }
    let postObj = {
      Customer: customerSelectData.length > 0 ? customers : "",
      Engagement: engagement,
      EngagementType: engagementType,
      CostCenterId: costcenterId,
      Resource: resoucreSelectData.length > 0 ? resource : "",
      FromDate:
        fromDate !== null
          ? moment(fromDate).format(moment.HTML5_FMT.DATE)
          : null,
      ToDate:
        toDate !== null ? moment(toDate).format(moment.HTML5_FMT.DATE) : null,
      RoleId: employeeRoleId,
      EmployeeId : EmployeeId,
      sortColumn,
      sortDirection,
      searchText,
      pageSize,
      start,
    };

    responseApi(postObj);
  }, [sortDirection, sortColumn, searchText, start, pageSize]);

  const Validation = () => {
    let objError = {};

    if (fromDate == undefined || fromDate == null) {
      objError["fromDate_isEmpty"] = "date can not be empty";
    }

    if (toDate == undefined || toDate == null) {
      objError["toDate_isEmpty"] = "date can not be empty";
    }

    formErrorObj = objError;
    setFormErrors(objError);
    const isEmpty = Object.keys(objError).length === 0;

    return isEmpty;
  };

  const ConvertArrayToString = (arr) => {
    let s = [];
    arr.map((i) => s.push(i.value));
    return s.join(",");
  };

  const engagementApiCall = async () => {
    let x = [];
    customerSelectData.map((i) => {
      x.push(i.value);
    });

    let postObject = {
      searchFor: "periodCustomerEngagement",
      searchValue: 1,
      CustomerId: x,
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let customerArray = [];
      let s = "";
      s.toLowerCase();
      await data.map((x: any) => {
        let tempObj = {
          value: x.id,
          label: x.name,
        };
        customerArray.push(tempObj);
      });
      customerArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
      setEngagementOptions(customerArray);
    }
  };

  const GetCostCenterOptions = async () => {
    let postObject = {
      searchFor: "costCenter",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);

    if (data !== null) {
      let options = [];
      data.map((item, index) => {
        options.push({ value: item.value, label: item.label, id: item.value });
      });
      options.sort((a, b) => a.label.localeCompare(b.label));
      setCostCenterOptions(options);
    }
  };

  const engagementTypeApiCall = async () => {
    let x = [];

    let postObject = {
      searchFor: "periodEngagementType",
      searchValue: 1,
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let customerArray = [];

      await data.map((x: any) => {
        let tempObj = {
          value: x.id,
          label: x.name,
        };
        customerArray.push(tempObj);
      });
      customerArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
      setEngagementTypeOptions(customerArray);
    }
  };

  const resourceApiCall = async () => {
    let x = [];

    let postObject = {
      searchFor: "periodResource",
      searchValue: 1,
    };

    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let customerArray = [];

      await data.map((x: any) => {
        let tempObj = {
          value: x.id,
          label: x.name,
        };
        customerArray.push(tempObj);
      });
      customerArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
      setResourceOptions(customerArray);
    }
  };

  const ExportToExcel = () => {
    let customers = ConvertArrayToString(customerSelectData);
    let resource = ConvertArrayToString(resoucreSelectData);
    let engagement = ConvertArrayToString(engagementSelectedData);
    let engagementType = ConvertArrayToString(engagementTypeSelectedData);
    let costcenterId = ConvertArrayToString(costCenterSelectData);
    let postObj = {
      Customer: customerSelectData.length > 0 ? customers : "",
      Engagement: engagement,
      EngagementType: engagementType,
      Resource: resoucreSelectData.length > 0 ? resource : "",
      CostCenterId: costcenterId,
      FromDate:
        fromDate !== null
          ? moment(fromDate).format(moment.HTML5_FMT.DATE)
          : null,
      ToDate:
        toDate !== null ? moment(toDate).format(moment.HTML5_FMT.DATE) : null,
      RoleId : employeeRoleId,
      EmployeeId : EmployeeId,
      sortColumn,
      sortDirection,
      searchText,
      pageSize: count,
      start,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",

        //data: Response,
        url: NewPeriodReportExportToExcel,
        //data:JSON,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
        data: postObj,
      })
      .then((response) => {
        fileDownload(response.data, "Summary Period Report.xlsx");
      })
      .catch((error) => {
        console.log(error.response.data);
      });
  };

  const customerApiCall = async () => {
    let postObject = {
      searchFor: "customer",
      searchValue: 1,
    };
    const { data } = await APICall(GetDropDownList, "POST", postObject);
    if (data != undefined || data != null) {
      let customerArray = [];
      await data.map((customer: any) => {
        let tempObj = {
          abb: customer.abbreviation,
          value: customer.id,
          label: customer.name,
        };
        customerArray.push(tempObj);
      });
      customerArray.sort((a, b) =>
        a.label.toLowerCase().localeCompare(b.label.toLowerCase())
      );
      setCustomerOptions(customerArray);
    }
  };
  const submitFunc = (api) => {
    if (api === "submit") {
      let customers = ConvertArrayToString(customerSelectData);
      let resource = ConvertArrayToString(resoucreSelectData);
      let engagement = ConvertArrayToString(engagementSelectedData);
      let engagementType = ConvertArrayToString(engagementTypeSelectedData);
      let costcenterId = ConvertArrayToString(costCenterSelectData);
      if(RoleIdArray.includes("3")){
        setEmployeeRoleId(3);
      }else if(RoleIdArray.includes("8")){
        setEmployeeRoleId(8);
      }else if(RoleIdArray.includes("2")){
        setEmployeeRoleId(2);
      }else if(RoleIdArray.includes("1")){
        setEmployeeRoleId(1);
      } 
      let postObj = {
        Customer: customerSelectData.length > 0 ? customers : "",
        Engagement: engagement,
        EngagementType: engagementType,
        CostCenterId: costcenterId,
        Resource: resoucreSelectData.length > 0 ? resource : "",
        FromDate:
          fromDate !== null
            ? moment(fromDate).format(moment.HTML5_FMT.DATE)
            : null,
        ToDate:
          toDate !== null ? moment(toDate).format(moment.HTML5_FMT.DATE) : null,
        RoleId : employeeRoleId,
        EmployeeId : EmployeeId,
        sortColumn,
        sortDirection,
        searchText,
        pageSize,
        start: 0,
      };

      let check = Validation();
      if (check) {
        responseApi(postObj);
      }
    } else {
      setCustomerSelectData([]);
      setResourceSelectData([]);
      setEngagementSelectedData([]);
      setEngagementTypeSelectedData([]);
      setCostCenterSelectData([]);
      setFromDate(null);
      setToDate(null);
      setFormErrors({});
    }
  };

  const responseApi = async (obj) => {
    showLoader();
    const { data } = await APICall(GetSumPeriodReportData, "POST", obj);
    if (data !== null) {
      setRequestObject(data.data);
      setCount(data.count);
    }
    hideLoader();
  };

  const gridColumns = [
    { name: "customer", label: "Customer" },
    { name: "engagementType", label: "Engagement type" },
    { name: "engagement", label: "Engagement" },
    { name: "applicationName", label: "Application" },
    { name: "phaseName", label: "Phase" },
    { name: "requirement", label: "Requirement" },
    {
      name: "title",
      label: "Title",
      setCellProps: () => ({ style: { minWidth: "800px" } }),
    },
    { name: "description", label: "Description" },

    { name: "assignedTo", label: "Assigned to" },
    {
      name: "timeSheetDate",
      label: "Timesheet date",
      options: {
        display: false,
      },
    },
    {
      name: "plannedHours",
      label: "Planned hours",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    {
      name: "actualHours",
      label: "Actual hours",
      options: {
        setCellProps: () => ({
          align: "right",
        }),
        setCellHeaderProps: () => ({ style: { justifyContent: "right" } }),
      },
    },
    { name: "status", label: "Status" },
    {
      name: "actualStartDate",
      label: "Start date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value == null) {
            return <p></p>;
          } else {
            return <p>{moment(value).format(moment.HTML5_FMT.DATE)}</p>;
          }
        },
      },
    },
    {
      name: "actualEndDate",
      label: "End date",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value == null) {
            return <p></p>;
          } else {
            return <p>{moment(value).format(moment.HTML5_FMT.DATE)}</p>;
          }
        },
      },
    },
    {
      name: "isChargeable",
      label: "Is Chargeable",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          if (value === undefined) {
            return <p></p>;
          } else if (value === true) {
            return <p>Yes</p>;
          } else {
            return <p>No</p>;
          }
        },
      },
    },
    { name: "noChargesReason", label: "No charge reason" },
    { name: "remark", label: "Remark" },
  ];

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Summary Period "} />

      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-end gap-2">
              <button
                onClick={() => ExportToExcel()}
                className="btn btn-export"
              >
                Export to Excel
              </button>
              <a className="filterIcon" onClick={toggleFilter}>
                <i className="fa fa-filter"></i>
              </a>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Customer</label>
                    <SelectForm
                      value={customerSelectData}
                      onChange={(e) => SelectOnChange(e, "customer")}
                      options={customerOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Engagement Type</label>
                    <SelectForm
                      value={engagementTypeSelectedData}
                      onChange={(e) => SelectOnChange(e, "engagementType")}
                      options={engagementTypeOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Engagement </label>
                    <SelectForm
                      value={engagementSelectedData}
                      onChange={(e) => SelectOnChange(e, "engagement")}
                      options={engagementOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Resource</label>
                    <SelectForm
                      value={resoucreSelectData}
                      onChange={(e) => SelectOnChange(e, "resource")}
                      options={resourceOptions}
                      isMulti
                      isSearchable={true}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      noIndicator={false}
                      noSeparator={false}
                      placeholder="Select"
                    />
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="d-block">
                      From Date <sup>*</sup>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="From Date"
                        value={fromDate}
                        onChange={(e) => SelectOnChange(e, "fromDate")}
                        inputFormat="dd/MM/yyyy"
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                    <p style={{ color: "red" }}>
                      {formErrors["fromDate_isEmpty"]}
                    </p>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label className="d-block">
                      To Date <sup>*</sup>
                    </label>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="To Date"
                        value={toDate}
                        onChange={(e) => SelectOnChange(e, "toDate")}
                        inputFormat="dd/MM/yyyy"
                        minDate={fromDate}
                        renderInput={(params) => (
                          <TextField size="small" {...params} />
                        )}
                      />
                    </LocalizationProvider>
                    <p style={{ color: "red" }}>
                      {formErrors["toDate_isEmpty"]}
                    </p>
                  </div>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Vertical</label>
                    <SelectForm
                      value={costCenterSelectData}
                      onChange={(e) => SelectOnChange(e, "costCenter")}
                      options={costCenterOptions}
                      isMulti
                      isSearchable={false}
                      isClearable={true}
                      closeMenuOnSelect={false}
                      hideSelectedOptions={false}
                      placeholder="Select Vertical"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    {/* <Tooltip title="Export to excel">
                        <button
                          onClick={() => ExportToExcel()}
                          className="btn btn-success mr-2"
                        >
                          <i className="fa-solid fa-file-arrow-down"></i>
                        </button>
                      </Tooltip> */}

                    <button
                      onClick={() => submitFunc("reset")}
                      className="btn btn-reset"
                      // disabled={state !== null ? true : false}
                    >
                      Reset
                    </button>
                    <button
                      // style={{ background: "#96c61c" }}
                      onClick={() => submitFunc("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={requestObject}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPeriodReport;
